<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Lead Time</li>
		</ol>

        <h1 class="page-header">Lead Time</h1>
        <hr>
        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row ">
                <!-- <div class="col-lg-3 col-xs-12 " style="padding-left:0" >
                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-3 col-form-label">Status</label>
                        <div class="col-sm-9">
                            <select class="form-control" style="width:100%" v-model="filter.status">
                                <option value="" selected>All Status</option>
                                <option value="Success">Success</option>
                                <option value="Failed">Failed</option>
                            </select>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-2 col-form-label col-xs-12"  style="padding-left:0">Month </label>
                        <select class="form-control w-75" v-model="filter.month">
                            <option v-for="(month, index) in monthList" :value="index">{{month}}</option>

                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-2 col-form-label col-xs-12"  style="padding-left:0">Year</label>
                        <select class="form-control w-75" v-model="filter.year">
                            <option v-for="year in yearList">{{year}}</option>

                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-2 offset-lg-4 col-xs-12">
                    <input type="button" class="btn btn-primary float-right" style="width:100%" @click="search()" value="Search"></input>
                </div>
            </div>
        </panel>
        <br>
        <h4>Lead Time (ADM to DPDC PST)</h4>
        <hr>
        <LeadTimeBoxPlot :data="data" v-if="data"></LeadTimeBoxPlot>
        <LeadTimeTable :data="data" v-if="data" class="mt-4"></LeadTimeTable>
    </div>
</template>

<script>
import LeadTimeBoxPlot from './childComponents/charts/LeadTimeBoxPlot'
import LeadTimeTable from './childComponents/LeadTimeTable'

export default {
    components : {
       LeadTimeBoxPlot,
       LeadTimeTable
    },
    data(){
        let yearList = [];
        let yearNow = new Date().getFullYear();
        for(var i = 0 ; i < 10 ; i++){
            yearList.push(yearNow - i);
        }
        var filter = {
            month : new Date().getMonth(),
            year : new Date().getFullYear(),
        }
        
        return {
            monthList : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
            yearList : yearList,
            filter : filter,
            data : null
        }
    },
    mounted(){
        this.getData();
    },
    methods : {
        getData(){
            let url = "/api/dashboard/leadTime"

            this.$http.get(url + this.$store.state.filterUrl)
            .then((resp)=>{
                // this.data = resp.data.data;
                var data = resp.data.data;

                var keys = Object.keys(data[0]);
                for(var i = 0 ; i < data.length ; i ++){
                    for(var j = 0 ; j < keys.length ; j ++){
                        if(keys[j] == 'day') continue;
                        
                        let chartValue = Math.round(data[i][keys[j]] / 60 * 100) / 100
                        
                        var quotient = Math.floor(data[i][keys[j]] / 60);
                        var remainder = data[i][keys[j]] % 60;

                        data[i][keys[j]] = chartValue;
                        data[i][keys[j] + "string"] = quotient + " h and " + remainder + " min"
                    }
                }

                this.data = data;
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        beforeDestroy(){
            am4core.disposeAllCharts();
            this.$store.state.filterUrl = '';
        },
        async search(){
            await this.initialiseFilter();
            await this.getData()

            this.filterTable = JSON.parse(JSON.stringify(this.filter))
            this.$store.state.updateData++;
        },
        initialiseFilter(){
            var keys = Object.keys(this.filter);
            
            let stringUrl = '?';
            var queryParams = this.filter;

            for(var i = 0 ; i < keys.length; i++){
                
                stringUrl += `${keys[i]}=${queryParams[keys[i]]}&`;
                
            }
            this.$store.state.filterUrl = stringUrl;
            this.filterReady = true;
        },
    }
}
</script>